module.exports = __webpack_public_path__ + "img/4460c2a.jpg";